import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 14 14",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.4444 12.8129H1.55554V11.2573H12.4444V12.8129Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.62649 7.20248L10.0028 4.72652L10.8889 5.64969L6.99997 9.70161L3.11108 5.64969L3.99711 4.72652L6.37345 7.20248V1.92383H7.62649V7.20248Z",
		fill: "currentColor"
	})]
});
export default SvgDownload;
